import React from 'react';
import { getParticipantIdFromSearchParams } from '../utils/urlParams';
import StudyCompletionThankYou from './StudyCompletionThankYou';

/** Legacy route — same thank-you UI as end of demographics, no auto-redirect. */
const ProlificThankYouPage: React.FC = () => {
  const participantId = getParticipantIdFromSearchParams(window.location.search);
  return <StudyCompletionThankYou participantId={participantId} />;
};

export default ProlificThankYouPage;
